import { type FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import {
  useBoardId,
  useEnterpriseId,
  useWorkspaceId,
} from '@trello/id-context';
import { Button } from '@trello/nachos/button';

import type { OnboardingScreen } from './SplitScreenOnboarding';

import styles from './SkipButton.less';

interface SkipButtonProps {
  onSkipButtonClick: () => void;
  screen: OnboardingScreen;
}

export const SkipButton: FunctionComponent<SkipButtonProps> = ({
  onSkipButtonClick,
  screen,
}) => {
  const boardId = useBoardId();
  const workspaceId = useWorkspaceId();
  const enterpriseId = useEnterpriseId();

  const onClick = () => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'skipOnboardingButton',
      source:
        screen === 'landing'
          ? 'splitScreenOnboardingLandingScreen'
          : 'splitScreenOnboardingCarouselScreen',
      containers: formatContainers({ boardId, workspaceId, enterpriseId }),
    });

    onSkipButtonClick();
  };
  return (
    <div className={styles.container}>
      <Button
        onClick={onClick}
        iconAfter={<ArrowRightIcon label="Skip" color={'currentColor'} />}
        className={styles.button}
      >
        <FormattedMessage
          id="templates.split_screen.onboarding.skip"
          defaultMessage="Skip"
          description="Skip button"
        />
      </Button>
    </div>
  );
};
